// Main entry point - Universal (Browser + Backend compatible)
// Export only browser-safe modules
export * from './src/entity.js'
export * from './src/diagram.js'
export * from './src/objects.js'
export * from './src/context.js'
export * from './src/authorizer.js'
